import DialogLayoutV2 from '../dialog-layoutV2';

/*
 * Confirmation step for the "Clear Form" action on every input page (Fees,
 * Docs, Refi-Docs, Lien & Title and the multi-step form).
 *
 * Built on DialogLayoutV2 -- the same shell components/title/Dialog.js uses for
 * the "Are you sure you want to go back?" prompt -- so every destructive
 * confirmation in the app shares one look: 430px card, 20px radius, centred
 * heading over supporting copy, and a footer with the secondary (cancel) action
 * on the left and the primary (confirm) action on the right. Styling comes from
 * .primary-button / .secondary-button in custom.css, so the brand green stays
 * in one place rather than being restated here.
 */
function ClearFormDialog({ open, onConfirm, onClose }) {
  const content = (
    <div className="text-center">
      <div className="text-2xl font-semibold text-gray-800 mb-2">
        Clear this form?
      </div>
      <div className="text-gray-600">
        This will clear every field you have entered on this form. This cannot be undone.
      </div>
    </div>
  );

  const footerProps = {
    primaryButton: {
      text: 'Yes, Clear Form',
    },
    secondaryButton: {
      text: 'Cancel',
    },
  };

  return (
    <DialogLayoutV2
      open={open}
      fullScreen={false}
      maxWidth="sm"
      content={content}
      onClose={onClose}
      onSubmit={onConfirm}
      footerProps={footerProps}
    />
  );
}

export default ClearFormDialog;
